/*!
 * Copyright 2022 Cognite AS
 */

export const DEFAULT_POINT_CLOUD_METADATA_FILE = 'ept.json';
export const DEFAULT_POINT_CLOUD_CLASS_DEFINITION_FILE = 'classificationSets.json';
